import React from 'react'
import './Skeleton.sass'
import Skeleton from 'react-loading-skeleton'

const ThemedSkeleton = ({ style, ...props }) => (
  <Skeleton
    {...props}
    style={{
      ...style,
      backgroundColor: 'var(--background)',
      backgroundImage: 'none',
      animation: 'none',
    }}
  />
)
export default ThemedSkeleton
